import { useEffect, useState } from "react";
import axios from "axios";
import { Bot, ChevronRight } from "lucide-react";
import { getSessionToken } from "@/utils/auth";

const API = `${window.APP_CONFIG?.BACKEND_URL || process.env.REACT_APP_BACKEND_URL}/api`;

export function AIDraftsBanner() {
  const [count, setCount] = useState(0);
  useEffect(() => {
    axios.get(`${API}/admin/ai-sms/pending-count`, { headers: { Authorization: `Bearer ${getSessionToken()}` } })
      .then((r) => setCount(r.data.pending || 0)).catch(() => {});
  }, []);
  if (!count) return null;
  return (
    <a href="/ai-texts" data-testid="ai-drafts-banner"
      className="mb-4 flex items-center justify-between gap-2 rounded-xl border-2 border-amber-300 bg-amber-50 px-4 py-3 text-sm text-amber-900 font-semibold">
      <span className="flex items-center gap-2"><Bot className="w-5 h-5" /> {count} AI text{count === 1 ? "" : "s"} waiting for your approval</span>
      <ChevronRight className="w-4 h-4" />
    </a>
  );
}
